import { SET_NAV_TOOLBAR_ITEMS, CLEAR_NAV_TOOLBAR_ITEMS } from "../actions/actionTypes";

export default function toolbarItems(state = [], action) {
  switch (action.type) {
    case SET_NAV_TOOLBAR_ITEMS:
      return action.toolbarItems;
    case CLEAR_NAV_TOOLBAR_ITEMS:
      return [];
    default:
      return state;
  }
}
